<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: projectId}}">Project Overview</router-link></li>
              <li><router-link :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}">Mailing Review</router-link></li>
              <li><router-link :to="{name: 'Mailing', params: {project_id: projectId, question_id: questionId, mailing_id: mailingId}}">Mailing</router-link></li>
              <li class="active">Mailing Expert</li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Mailing - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: projectId}}">{{project.name}}</router-link>
          </h3>
          <small>Expert selection page</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="hpanel">

        <div class="panel-heading">
          Subproject selection
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12">
              <v-select2 v-if="lists" :options="lists" label="title" v-model="listSelected" placeholder="Select a list"/>
            </div>
          </div>
        </div>

      </div>

      <div class="hpanel">

        <div class="panel-heading">
          Experts
          <div class="panel-tools">
            <button class="btn btn-info btn-xs btn-outline" @click="addExpert(null)"><i class="fa fa-plus"></i> Add expert</button>
          </div>
        </div>

        <div class="panel-body">
          <experts-list-selection :experts="experts" :editExpert="editExpert"/>
        </div>

      </div>

      <div class="hpanel">

        <div class="panel-heading">
          Organisations
          <div class="panel-tools">
            <button class="btn btn-info btn-xs btn-outline" @click="addCompany(null)"><i class="fa fa-plus"></i> Add company</button>
          </div>
        </div>

        <div class="panel-body">
          <companies-list-selection :companies="companies" :editCompany="editCompany"/>
        </div>

      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-heading">
              Actions
            </div>
            <div class="panel-body text-center">
              <div class="col-xs-4">
                <router-link class="btn btn-info" :to="{name: 'Mailing', params: {project_id: projectId, question_id: questionId, mailing_id: mailingId}}"><i class="fa fa-arrow-left"></i> Back to email text edit</router-link>
              </div>
              <div class="col-xs-4">
              </div>
              <div class="col-xs-4 border-right">
                <vue-ladda :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" @click="validateSelection"><i class="fa fa-arrow-right"></i> Proceed with emailing</vue-ladda>
                <span class="help-block m-b-none"> You will be able to review before sending </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="modal fade" id="modalEditExpert" tabindex="-1" role="dialog"  aria-hidden="true">
      <div v-if="expertToEdit" class="modal-dialog modal-lg">
        <form v-on:submit="submitExpertEdit">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
              <h4 class="modal-title">Edit Expert informations</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12">
                  <h4>Expert Name</h4>
                  <div class="form-group col-xs-6">
                    <label for="firstName" class="required">First Name</label>
                    <input type="" v-model="expertToEdit.firstName" id="firstName" class="form-control" name="firstName"  required>
                    <span v-if="errorFirstName " :class="{'has-error' : errorFirstName , 'has-success' : errorFirstName === false}" class="help-block text-danger">{{ errorFirstName }}</span>
                  </div>
                  <div class="form-group col-xs-6" >
                    <label for="LastName" class="required">Last name</label>
                    <input type="" v-model="expertToEdit.lastName" id="lastName" class="form-control" name="lastName"  required>
                    <span v-if="errorLastName" :class="{'has-error' : errorLastName , 'has-success' : errorLastName === false}" class="help-block text-danger">{{ errorLastName }}</span>
                  </div>
                </div>
                <div class="col-xs-12">
                  <h4>Expert Affiliation & Email</h4>
                  <div v-for="(affiliation, key) in expertToEdit.author_organisations" v-bind:key="key">
                    <div class="row">
                      <div class="col-md-11 col-xs-10">
                        <div class="form-group col-xs-6">
                          <label for="companyName" class="">Company name</label>
                          <input v-if="affiliation.organisation" type="" v-model="affiliation.organisation.organisationName" id="companyName" class="form-control" name="companyName">
                        </div>
                        <div class="form-group col-xs-6">
                          <label for="email" :class="{required: affiliation.id}">Email</label>
                          <input v-model="affiliation.email" id="email" class="form-control" name="email" :required="affiliation.id">
                          <span v-if="errorEmail && errorEmail[key]" class="help-block text-danger" :class="{'has-error' : errorEmail[key] , 'has-success' : errorEmail === false}">{{ errorEmail[key] }}</span>
                        </div>
                      </div>
                      <div class="col-md-1 col-xs-2" style="margin: 25px 0;">
                        <button v-if="!affiliation.id" class="btn btn-xs btn-outline btn-danger" @click="removeAffiliation($event, key)" ><i class="fa fa-remove"></i> Delete</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center" style="margin-top: 10px">
                  <button class="btn btn-xs btn-outline btn-success" @click="addAffiliation" ><i class="fa fa-plus"></i>Add</button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal fade" id="modalEditCompany" tabindex="-1" role="dialog"  aria-hidden="true">
      <div v-if="companyToEdit" class="modal-dialog modal-lg">
        <form v-on:submit="submitCompanyEdit">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
              <h4 class="modal-title">Edit Company information</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12">
                  <h4>Organisation Description</h4>
                  <div class="form-group col-xs-6" >
                    <label for="LastName" class="required">Name</label>
                    <input type="" v-model="companyToEdit.lastName" id="lastName" class="form-control" name="lastName" required>
                    <span v-if="errorLastName" :class="{'has-error' : errorLastName , 'has-success' : errorLastName === false}" class="help-block text-danger">{{ errorLastName }}</span>
                  </div>
                </div>
                <div class="col-xs-12">
                  <h4>Organisation Email</h4>
                  <div v-for="(affiliation, key) in companyToEdit.author_organisations" v-bind:key="key">
                    <div class="row">
                      <div class="col-md-11 col-xs-10">
                        <div class="form-group col-xs-6">
                          <label for="email" :class="{required: affiliation.id}">Email</label>
                          <input v-model="affiliation.email" id="email" class="form-control" name="email" :required="affiliation.id">
                          <span v-if="errorEmail && errorEmail[key]" class="help-block text-danger" :class="{'has-error' : errorEmail[key] , 'has-success' : errorEmail === false}">{{ errorEmail[key] }}</span>
                        </div>
                      </div>
                      <div class="col-md-1 col-xs-2" style="margin: 25px 0;">
                        <button v-if="!affiliation.id" class="btn btn-xs btn-outline btn-danger" @click="removeAffiliation($event, key)" ><i class="fa fa-remove"></i> Delete</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center" style="margin-top: 10px">
                  <button class="btn btn-xs btn-outline btn-success" @click="addAffiliation" ><i class="fa fa-plus"></i>Add</button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'
import ExpertsListSelection from '../../components/companyAuthor/ExpertsSelection'
import CompaniesListSelection from '../../components/companyAuthor/CompaniesSelection'

export default {
  components: {
    CompaniesListSelection,
    ExpertsListSelection,
    VueLadda,
    vSelect2
  },
  props: [],
  name: 'MailingExpertSelection',
  methods: {
    getResources: function () {
      this.axios.get('/mailing/' + this.mailingId + '?relations={mailingAuthors}')
        .then((response) => {
          if (response.data) {
            this.mailingSelectedExperts = response.data.mailing_authors
          }
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })

      this.axios.get('/project/' + this.projectId + '?relations={lists}')
        .then((response) => {
          this.project = response.data
          this.lists = response.data.lists
          this.listSelected = this.lists[0]
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    validateSelection: function () {
      let expertsSelected = []

      this.experts.forEach((expert) => {
        let tmpExpert = Object.assign({}, expert)

        let authorOrganisations = expert.author_organisations.filter((affiliation) => {
          return affiliation.selected === true
        })

        if (authorOrganisations.length !== 0) {
          tmpExpert.author_organisations = authorOrganisations
          expertsSelected.push(tmpExpert)
        }
      })

      this.companies.forEach((company) => {
        let tmpCompany = Object.assign({}, company)

        let authorOrganisations = company.author_organisations.filter((affiliation) => {
          return affiliation.selected === true
        })

        if (authorOrganisations.length !== 0) {
          tmpCompany.author_organisations = authorOrganisations
          expertsSelected.push(tmpCompany)
        }
      })

      this.axios.post('/mailing/' + this.mailingId + '/experts', {
        experts: expertsSelected
      })
        .then((response) => {
          this.submit.loading = false

          this.$router.push({name: 'MailingSummary', params: {project_id: this.projectId, question_id: this.questionId, mailing_id: this.mailingId}})
        }).catch((error) => {})
    },
    editExpert: function (expert) {
      this.expertToEdit = expert
    },
    editCompany: function (company) {
      this.companyToEdit = company
    },
    addExpert: function (expert) {
      this.expertToAdd = {}
    },
    addCompany: function (company) {
      this.companyToAdd = {}
    },
    addAffiliation: function (event) {
      event.preventDefault()
      if (this.expertToEdit !== null) {
        this.expertToEdit.author_organisations.push({
          organisation: {
            organisationName: null
          },
          country: null,
          email: null
        })
      } else {
        this.companyToEdit.author_organisations.push({
          organisation: {
            organisationName: null
          },
          country: null,
          email: null
        })
      }
    },
    removeAffiliation: function (event, index) {
      event.preventDefault()
      if (this.expertToEdit !== null) {
        this.expertToEdit.author_organisations.splice(index, 1)
      } else if (this.companyToEdit !== null) {
        this.companyToEdit.author_organisations.splice(index, 1)
      }
    },
    submitExpertEdit: function (e) {
      e.preventDefault()
      this.submit.loading = true

      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      if (typeof this.expertToEdit.authorID !== 'undefined') {
        this.axios.patch('/expert/' + this.expertToEdit.authorID, {
          first_name: this.expertToEdit.firstName,
          last_name: this.expertToEdit.lastName,
          author_organisations: this.expertToEdit.author_organisations
        })
          .then((response) => {
            this.submit.loading = false

            this.getResources()
            $('#modalEditExpert').modal('hide')
          }).catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorFirstName = errors['first_name'][0]
                break
              case 2:
                this.errorLastName = errors['last_name'][0]
                break
              case 3:
                this.errorEmail = {}
                Object.keys(errors).forEach((error) => {
                  let matches = error.match(/\.(\d)\./)
                  this.errorEmail[matches[1]] = errors[error][0].replace(error, 'email')
                })
                break
            }
            this.submit.loading = false
          })
      } else if (this.expertToAdd !== null) {
        this.axios.post('/expert/', {
          first_name: this.expertToEdit.firstName,
          last_name: this.expertToEdit.lastName,
          author_organisations: this.expertToEdit.author_organisations,
          list_id: this.listSelected.id
        })
          .then((response) => {
            this.submit.loading = false

            this.getResources()
            $('#modalEditExpert').modal('hide')
          }).catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorFirstName = errors['first_name'][0]
                break
              case 2:
                this.errorLastName = errors['last_name'][0]
                break
              case 3:
                this.errorEmail = {}
                Object.keys(errors).forEach((error) => {
                  let matches = error.match(/\.(\d)\./)
                  this.errorEmail[matches[1]] = errors[error][0].replace(error, 'email')
                })
                break
            }
            this.submit.loading = false
          })
      }
    },
    submitCompanyEdit: function (e) {
      e.preventDefault()
      this.submit.loading = true

      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      if (typeof this.companyToEdit.authorID !== 'undefined') {
        this.axios.patch('/company/' + this.companyToEdit.authorID, {
          last_name: this.companyToEdit.lastName,
          author_organisations: this.companyToEdit.author_organisations
        })
          .then((response) => {
            this.submit.loading = false

            this.getResources()
            $('#modalEditCompany').modal('hide')
          }).catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorFirstName = errors['first_name'][0]
                break
              case 2:
                this.errorLastName = errors['last_name'][0]
                break
              case 3:
                this.errorEmail = {}
                Object.keys(errors).forEach((error) => {
                  let matches = error.match(/\.(\d)\./)
                  this.errorEmail[matches[1]] = errors[error][0].replace(error, 'email')
                })
                break
            }
            this.submit.loading = false
          })
      } else if (this.companyToAdd !== null) {
        this.axios.post('/company/', {
          last_name: this.companyToEdit.lastName,
          author_organisations: this.companyToEdit.author_organisations,
          list_id: this.listSelected.id
        })
          .then((response) => {
            this.submit.loading = false

            this.getResources()
            $('#modalEditCompany').modal('hide')
          }).catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorLastName = errors['last_name'][0]
                break
              case 2:
                this.errorEmail = {}
                Object.keys(errors).forEach((error) => {
                  let matches = error.match(/\.(\d)\./)
                  this.errorEmail[matches[1]] = errors[error][0].replace(error, 'email')
                })
                break
            }
            this.submit.loading = false
          })
      }
    }
  },
  watch: {
    expertToEdit: function (expert) {
      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      if (expert !== null) {
        expert.author_organisations.forEach((affiliation) => {
          if (affiliation.organisations_id === null) {
            affiliation.organisation = {
              organisationName: null
            }
          }
        })
        $('#modalEditExpert').modal('show')
      }
    },
    companyToEdit: function (company) {
      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      if (company !== null) {
        // company.author_organisations.forEach((affiliation) => {
        //   if (affiliation.organisations_id === null) {
        //     affiliation.organisation = {
        //       organisationName: null
        //     }
        //   }
        // })
        $('#modalEditCompany').modal('show')
      }
    },
    expertToAdd: function (expert) {
      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      this.expertToEdit = {
        firstName: null,
        lastName: null,
        author_organisations: [{
          organisation: {
            organisationName: null
          },
          email: null
        }]
      }
    },
    companyToAdd: function (company) {
      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      this.companyToEdit = {
        firstName: null,
        lastName: null,
        author_organisations: [{
          organisation: {
            organisationName: null
          },
          email: null
        }]
      }
    },
    listSelected: function (list) {
      if (list !== null) {
        this.axios.get('/list/' + list.id + '/authorEmails')
          .then((response) => {
            this.experts = []
            this.companies = []
            response.data.authors.forEach((item, key) => {
              item.author_organisations.sort((authorOrganisation1, authorOrganisation2) => {
                return authorOrganisation2.emailScore - authorOrganisation1.emailScore
              })

              item.author_organisations = item.author_organisations.slice(0, 3)

              if (item.type === 'company') {
                this.companies.push(item)
              } else {
                this.experts.push(item)
              }
            })

            let MailingSelectedExperts = this.mailingSelectedExperts
            if (MailingSelectedExperts !== 0) {
              this.experts.forEach((expert) => {
                expert.author_organisations.forEach((affiliation) => {
                  MailingSelectedExperts.forEach((author) => {
                    if (affiliation.email === author.email) {
                      affiliation.selected = true
                    }
                  })
                })
              })
              this.companies.forEach((company) => {
                company.author_organisations.forEach((affiliation) => {
                  MailingSelectedExperts.forEach((author) => {
                    if (affiliation.email === author.email) {
                      affiliation.selected = true
                    }
                  })
                })
              })
            }
          }).catch(function (error) {
          })
      } else {
        this.experts = null
      }
    }
  },
  data () {
    return {
      projectId: null,
      questionId: null,
      mailingId: null,
      lists: null,
      listSelected: null,
      experts: null,
      companies: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      expertToEdit: null,
      expertToAdd: null,
      errorFirstName: null,
      errorLastName: null,
      errorEmail: null,
      companyToEdit: null,
      companyToAdd: null,
      mailingSelectedExperts: [],
      project: null
    }
  },
  mounted () {
    $('#modalEditExpert').on('hidden.bs.modal', (e) => {
      this.expertToEdit = null
    })
  },
  beforeMount () {
    this.projectId = this.$route.params.project_id
    this.questionId = this.$route.params.question_id
    this.mailingId = this.$route.params.mailing_id

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/MailingExpertSelection.vue